<app-modal-basic
  #modal
  [dialogClass]="'modal-lg'"
  (closed)="fechar()"
  modalContentId="modalGerarMensalidades"
>
  <div class="app-modal-header">
    <h4 class="modal-title"><i class="fa fa-eye"></i> Visualizar pedidos de contratos</h4>
    <button type="button" class="close basic-close" (click)="fechar()">
      <span class="btn-close" aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="app-modal-body">
    <div class="row">
      <div class="col-12 mb-4">
        <h6>Pedidos gerados do contrato número: {{ numeroContrato }}</h6>
        <h6>Cliente: {{ clienteNome }}</h6>
      </div>
    </div>

    <div class="row">
      <div class="col-12">
        <app-dim-datatable
          #table
          [loading]="loading.table"
          [columns]="columns"
          [data]="contrato?.pedidos || []"
          [rowsOnPage]="20"
          [totalItems]="contrato?.pedidos?.length || 0"
          [serverPaginated]="false"
          [acoes]="true"
        >
          <ng-template #buttonsMaxTmpl let-row="row">
            <button
              class="btn btn-info btn-mini waves-effect waves-light"
              style="border-radius: 10%"
              type="button"
              placement="left"
              ngbTooltip="Abrir pedido em uma nova guia"
              (click)="redirectToPedido(row)"
            >
              <i class="fa fa-external-link"></i>
            </button>
          </ng-template>
        </app-dim-datatable>
      </div>
    </div>
  </div>

  <div class="app-modal-footer"></div>
</app-modal-basic>
